import React from 'react';
import { observer } from 'mobx-react';
import { Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

@observer
export default class Dispatches extends React.Component {
	render() {
		const rootPath = '/admin';
		const path = `${rootPath}/dispatches`;
		return (
			<div>
				<Route exact path={path} component={() => <List rootPath={rootPath} path={path} />} />
				<Route exact path={`${path}/:id`} component={() => <Edit rootPath={rootPath} path={path} />} />
			</div>
		);
	}
}
